<script lang="ts" setup>

import * as yup from "yup";
import {useForm} from "vee-validate";

const {emit} = useEventBus();
const {openModal, closeModal} = useModal();
const {signIn} = useAuth()
const route = useRoute()


const schema = yup.object({
  email: yup.string().email()
      .typeError('Informe um e-mail válido')
      .required('E-mail é obrigatório'),
  password: yup
      .string()
      .required('Senha é obrigatória')
});
const {handleSubmit} = useForm({validationSchema: schema});

const onSubmit = handleSubmit(async ({email, password}) => {
  const success = await signIn({
    email: email.trim().toLowerCase(),
    password: password.trim()
  });
  if (success) {
    closeModal('sign-modal')
    emit('login-success');

    if (route.query.redirect) {
      //@ts-ignore
      navigateTo(route.query.redirect)
    }
  }
});
</script>

<template>
  <div class="row mx-0 align-items-center">
    <div class="col-md-12 px-4 pt-2 pb-4 px-sm-5 pb-sm-5 pt-md-5">
      <h2 class="h3 mb-4 mb-sm-5">Olá! Bem vindo de volta.</h2>
      <!--      <a class="btn btn-outline-info w-100 mb-3" href="javascript:void(0);">-->
      <!--        <i class="fi-google fs-lg me-1"></i>Entrar com Google-->
      <!--      </a>-->
      <!--      <a class="btn btn-outline-info w-100 mb-3" href="javascript:void(0);">-->
      <!--        <i class="fi-facebook fs-lg me-1"></i>Entrar com Facebook-->
      <!--      </a>-->
      <!--      <div class="d-flex align-items-center py-3 mb-3">-->
      <!--        <hr class="w-100"/>-->
      <!--        <div class="px-3">Ou</div>-->
      <!--        <hr class="w-100"/>-->
      <!--      </div>-->
      <form @submit.prevent="onSubmit">
        <DynamicForm :fields="[
            { name: 'email', type: 'email', label: 'E-mail', placeholder: 'Digite o e-mail' },
            { name: 'forgotPassword', type: 'slot', customFieldSlot: 'forgotPassword' },
            { name: 'password', type: 'password', label: 'Senha', placeholder: 'Digite a senha' }
        ]">
          <template #forgotPassword>
            <a class="fs-sm float-end" @click="() => openModal('forgot-password-modal')">Esqueceu a Senha?</a>
          </template>
        </DynamicForm>
        <div class="mt-3">
          <button type="submit" class="btn btn-primary px-5">Entrar</button>
        </div>
      </form>
      <div class="mt-4 mt-sm-5">
        Ainda não possui uma conta?
        <a class="text-primary" style="cursor: pointer" @click="() => openModal('signup-modal')">Cadastre-se agora</a>
      </div>
    </div>
  </div>
</template>

<style>
</style>
